import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { MarketplaceListing } from '../types';
import {
  cardSx,
  nameSx,
  subSx,
  MONO,
  rarityHex,
  Pill,
  NftArt
} from './cardKit';
import { cardTitle } from '../../NFTCollection/components/CardInspectModal';

type Props = {
  listing: MarketplaceListing;
  cloudfrontBase?: string;
  cancelling: boolean;
  onCancel: (listingId: number) => void;
};

export const MyListingCard: React.FC<Props> = ({
  listing,
  cloudfrontBase,
  cancelling,
  onCancel
}) => {
  const imgSrc = cloudfrontBase
    ? `${cloudfrontBase}/${listing.nft.type}/${listing.nft.name}/${listing.nft.rarity}.png`
    : '';

  const status = listing.status;
  const statusColor =
    status === 'active' ? '#42e6a4' : status === 'sold' ? '#ff6b6b' : '#8b919c';
  const statusLabel =
    status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

  return (
    <Card sx={cardSx}>
      <NftArt
        imgSrc={imgSrc}
        alt={listing.nft.name}
        rarityColor={rarityHex(listing.nft.rarity)}
        topRight={<Pill color={statusColor}>{statusLabel}</Pill>}
      />

      <CardContent
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2 }}
      >
        <Typography sx={nameSx}>{cardTitle(listing.nft.name)}</Typography>

        <Box
          sx={{
            mt: 1,
            font: `900 20px ${MONO}`,
            color: '#ffcf40',
            fontVariantNumeric: 'tabular-nums',
            lineHeight: 1
          }}
        >
          {listing.priceInINC}
          <Box
            component="span"
            sx={{ ml: 0.5, font: `700 11px ${MONO}`, color: '#5c6b78' }}
          >
            INC
          </Box>
        </Box>
        <Typography sx={{ mt: 0.5, ...subSx }}>
          ~${listing.priceInUSD} USD
        </Typography>

        <Box sx={{ mt: 'auto', pt: 2 }}>
          {status === 'sold' && listing.buyer && (
            <Typography sx={subSx}>Sold to {listing.buyer.username}</Typography>
          )}

          {status === 'active' && (
            <Button
              variant="outlined"
              fullWidth
              disabled={cancelling}
              onClick={() => onCancel(listing.id)}
              sx={{
                fontWeight: 800,
                color: '#ff6b6b',
                borderColor: 'rgba(255, 107, 107, 0.5)',
                borderRadius: '9px',
                py: 1,
                '&:hover': {
                  borderColor: '#ff6b6b',
                  backgroundColor: 'rgba(255, 107, 107, 0.08)'
                },
                '&.Mui-disabled': {
                  color: 'rgba(255, 107, 107, 0.4)',
                  borderColor: 'rgba(255, 107, 107, 0.2)'
                }
              }}
            >
              {cancelling ? 'Cancelling…' : 'Cancel Listing'}
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
